module.exports = __webpack_public_path__ + "static/media/api.d7a7743b.svg";